/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.statistics', [])
    .factory('statisticsService', StatisticsService)
    .name;

/*@ngInject*/
function StatisticsService($http, $q) {

    var service = {
        getConverterStatistics: getConverterStatistics
    }

    return service;

    function createTimeParameters(timeline) {
        var parameters = "";
        if (timeline.day) {
            parameters += `?day=${timeline.day}`
        } else if (timeline.month) {
            parameters += `?month=${timeline.month}`
        }
        return parameters;
    }


    function getConverterStatistics (converterId, subEntity, metric, timeline) {
        var deferred = $q.defer();
        var url = `/api/statistics/converter/${converterId}/${subEntity}/${metric}/count`;
        url += createTimeParameters(timeline);
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/statistics.service.js